module.exports = __webpack_public_path__ + "img/nairobi.51a57c2f.png";